import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '../../store/types';
import type { DragName } from './constants';

const getDraggedItems = (state: AppState, name: DragName) =>
  state.draggedItemsReducer.items[name];

export const selectDraggedItemIds = createSelector(
  getDraggedItems,
  (draggedItems) => draggedItems.map((item) => item.id),
);

export const selectDraggedItemIdsSet = createSelector(
  selectDraggedItemIds,
  (selectedItemIds) => new Set(selectedItemIds),
);
